import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PanelComponent, PanelContentDirective } from './panel.component';



@NgModule({
  declarations: [
    PanelComponent,
    PanelContentDirective
  ],
  imports: [
    CommonModule
  ],
  exports: [
    PanelComponent,
    PanelContentDirective
  ]
})
export class PanelModule { }
